export enum ApiRoutes {
  LOGIN = "/token/pair",
  EXCHANGE = "/exchange",
  REFRESH_TOKEN = "/token/refresh",
  TRANSACTIONS = "/transaction",
  ONEDAYTRANSACTIONS = "/transaction/list",
  TRANSACTIONSPOS = "/transaction/pos",
  TRANSACTION_CHECK = "/transaction/check",
  CARD_PAYMENT = "/payment/pay",
  GROUP = "/group",
  BANKACCOUNT = "/bank-account",
  CRYPTOACCOUNT = "/crypto-account",
  CRYPTODEPOSIT = "/direct-transaction/deposit",
  CRYPTOWITHDRAW = "/direct-transaction/withdraw",
  IBANACCOUNT = "/direct-transaction/bank-account",
  CRYPTODEPOSITLIST = "/direct-transaction",
  CONTENTYPES = "/permission/content-type",
  CURRENCY = "/exchange/currencies",
  DEFAULT_FEES = "/transaction/default-fee",
  USERS = "/user",
  USERSFEE = "/user-info/fee",
  USERCLIENTS = "/client",
  SKIPKYC = "/client/anonymous",
  STAFF = "/staff",
  INBOX = "/notification",
  STATUS = "/status",
  GENERAL_STATUS = "/general-status",
  TRANSACTION_STATUS = "/transaction-status",
  KYC = "/kyc",
  KYC_TOKEN = "/kyc/token",
  CHANGE_PASSWORD = "/password/change",
  CHANGE_PASSWORD_EMAIL = "/password/change-by-email",
  SEND_FORGOT_PASSWORD_EMAIL = "/password/send-forgot-email",
  GET_BALANCE = "/balance",
  GET_BALANCE_PENDING = "/balance/pending",
  STATISTICS = "/statistics",
  LOGS = "/logs",
  CURRENCIES_COUNT = "/statistics/currencies-count",
  CRYPTO_STATS = "/crypto-stats",
  NOTIFICATIONSTATUS = "/notification/read",
  DEPOSITBANK="/deposit-bank",
  DEPOSITWALLET="/deposit-wallet",
  CLIENT_ACCESS = "/accessible-users",
  CLIENT = "/client/detailed",
  STAFF_ACCESS = "/staff",
  STAFF_PROMOTE = "/staff/promote",

  CONTACT_SUBMIT = "/contact",


  //NEW ROUTES FOR FORMS

  BUSINESSINFO = "/user-info/business",
  BUSINESSINFOSTATUS = "/user-info/business-status",
  BUSINESSINFOFILES = "/user-info/business-files",
  PAYMENT_CHECKOUT = "/payment/checkout",


  INDIVIDUALINFO = "/user-info/individual",
  INDIVIDUALINFOPLUS = "/user-info/solo-entrepreneur",
  INDIVIDUALINFOSTATUS = "/user-info/individual-status",
  INDIVIDUALINFOFILES = "/user-info/individual-files",

  QUESTIONARYINFO = "/user-info/financial",
  QUESTIONARYINFOSTATUS = "/user-info/financial-status",

  GENERALSTATUS = "/user-info/general-status",

  CLIENTINFO = "/user-info/client-info",

  GENERATE_RECEEIPT = "/pdf/receipt",
  GENERATE_INVOICE = "/pdf/invoice",

  ACTIVATE_USER = "/activate-user/activate",
  LIST_DEPOSIT_WALLET = "/deposit-wallet",
  DEPOSIT_WALLET = "/deposit-wallet/filtered",

  EXCHANGESETTINGS = "/exchange-settings",
  SEND_RECEIPT_EMAIL = "/pdf/send-receipt",

  VERRIFF_SESSION = "/veriff/save-session",
}
